import React, { useRef } from 'react';
import clipboardy from 'clipboardy';

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import './style.css';

interface IOidBadge {
    value: string;
}

const OidBadge: React.FC<IOidBadge> = ({ value }) => {
    const toastRef = useRef<Toast>(null);

    return (
        <>
            <Toast ref={toastRef} />
            <Button
                className='oid-badge p-button-rounded p-button-success'
                label={`${value.substring(0, 4)} ... ${value.substring(
                    value.length - 4
                )}`}
                tooltip={`Copy (${value})`}
                onClick={() =>
                    clipboardy.write(value).then(() =>
                        toastRef?.current?.show({
                            severity: 'success',
                            summary: 'Copied',
                            detail: 'OID copied to clipboard',
                            life: 3000,
                        })
                    )
                }
            />
        </>
    );
};

export default OidBadge;
